import '@material/web/button/outlined-button.js';
import '@material/web/button/filled-tonal-button.js';
import '@material/web/textfield/filled-text-field.js';
import '@material/web/select/outlined-select.js';
import '@material/web/select/filled-select.js';
import '@material/web/select/select-option.js';
import '@material/web/divider/divider.js';
import '@material/web/progress/circular-progress.js';

import ElementClassLoader from "./element-class-loader";
import AnalyticElement from "./commons/analytic-element";

declare global {
    interface Window {
        elementClassLoader: ElementClassLoader;
        storage: Storage;
        NODE_ENV: string
        gtag: Function;
        coreVersion: string;
    }
}

window.elementClassLoader = window.elementClassLoader || new ElementClassLoader();
window.NODE_ENV = "production";

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-event]').forEach((element) => {
        new AnalyticElement(element as HTMLElement);
    })
})